import { Directive } from '@angular/core';

@Directive({
  selector: '[nttBadgeStart]',
})
export class NttBadgeStart {}

@Directive({
  selector: '[nttBadgeEnd]',
})
export class NttBadgeEnd {}

@Directive({
  selector: '[nttBadgeContent]',
})
export class NttBadgeContent {}

@Directive({
  selector: '[nttBadgeAvatar]',
})
export class NttBadgeAvatar {}
